import React, {useState, useRef, useEffect} from 'react';
import './App.css';


const ChatMessageWelcome = () => {
  const textareaRefUser = useRef(null);
  const textareaRefBot = useRef(null);

  const autoResize = () => {
    if(textareaRefUser.current){
      // 重置高度以便重新计算
      textareaRefUser.current.style.height = 'auto';
      // 设置高度为滚动高度
      textareaRefUser.current.style.height = `${textareaRefUser.current.scrollHeight}px`;
    }
    if(textareaRefBot.current){
      // 重置高度以便重新计算
      textareaRefBot.current.style.height = 'auto';
      // 设置高度为滚动高度
      textareaRefBot.current.style.height = `${textareaRefBot.current.scrollHeight}px`;
    }
  };

  function getCurrentTime() {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'pm' : 'am';

      hours = hours % 12;
      hours = hours ? hours : 12; // 小时为 0 时，显示为 12
      const minutesStr = minutes < 10 ? '0' + minutes : minutes;

      const timeString =  '今天 ' + hours + ':' + minutesStr+ ' ' + ampm;
      return timeString;
  }

  useEffect(() => {
    autoResize();
  }, []);

  const handleInputChange = (e) => {
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
  };

  const messgaeWelcome = "欢迎使用昂听APP。我是您的智能助手。今天有什么可以帮到您的吗？"

  return (
    <div>
        <div className='container-center'>
          {getCurrentTime()}
        </div>

        <div className='container-left'>
          <label className='AIHeadLabel'>
          </label>
          <textarea className='chat-message-bot' value={messgaeWelcome}
          readOnly={true}
          onChange={handleInputChange}
          ref={textareaRefBot}
          >
          </textarea>
        </div>

    </div>


  );
};

export default ChatMessageWelcome;
